export type PaidSummaryDelta = {
  paidAmountDelta: number
  paidCountDelta: number
  dueAmountDelta: number
  dueCountDelta: number
}

type Listener = (delta: PaidSummaryDelta) => void

const listeners = new Set<Listener>()

export const subscribePaidSummaryAnimation = (listener: Listener): (() => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const publishPaidSummaryAnimation = (delta: PaidSummaryDelta): void => {
  listeners.forEach((listener) => listener(delta))
}
